export const SITE = {
  name: "TSM Group CLE",
  tagline: "Think Safe Mitigation",
  headline: "Know the risk. Make your next move.",
  serviceLine:
    "Business Risk Management | Workforce Services | Verification | Screening | Notary & Document Services",
  phone: "(216) 232-3090",
  phoneHref: "tel:+12162323090",
  email: "admin@tsmgroupcle.com",
  emailHref: "mailto:admin@tsmgroupcle.com",
  serviceArea: "Northeast Ohio",
  schedulingUrl: "https://calendly.com/admin-tsmgroupcle/services-consultation",
  social: [
    { label: "LinkedIn", href: "#" },
    { label: "Facebook", href: "#" },
    { label: "Instagram", href: "#" },
  ],
};

export const TSM4_PRODUCTS = [
  {
    name: "MITIVISE",
    label: "Risk & Compliance Platform",
    href: "/mitivise",
    status: "available",
    icon: "shield",
    description:
      "Identify risks, organize critical documentation, manage audits, develop standard operating procedures, and track operational compliance responsibilities.",
  },
  {
    name: "TSM Background Screening",
    label: "Workforce Screening",
    href: "/tsm4/background-screening",
    status: "available",
    icon: "user-check",
    description:
      "Business-focused background screening services designed to support workforce screening and informed hiring processes.",
  },
  {
    name: "TSM Drug Testing",
    label: "Workplace Testing",
    href: "/tsm4/drug-testing",
    status: "coming_soon",
    icon: "flask",
    description:
      "Workforce drug testing services designed to support employer screening programs and workplace readiness.",
  },
  {
    name: "TSM Fingerprinting",
    label: "Identity Verification",
    href: "/tsm4/fingerprinting",
    status: "coming_soon",
    icon: "fingerprint",
    description:
      "Fingerprinting services designed to support identity verification and eligible employment background check requirements.",
  },
];
